import { Box, LinearProgress } from '@mui/material';
import { incrementLinearProgress } from 'core/store/animationsSlice';
import { useAppSelector } from 'core/store/hooks';
import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { BRIGHT_BLUE } from 'utils/theme';

const LinearProgressBar = () => {
  const dispatch = useDispatch();
  const isClaimLoading = useAppSelector((state) => state.claimsV2.isClaimLoading);
  const linearProgressValue = useAppSelector((state) => state.animations.linearProgressValue);

  useEffect(() => {
    if (isClaimLoading) {
      const timer = setInterval(() => {
        dispatch(incrementLinearProgress());
      }, 1000);

      return () => {
        clearInterval(timer);
      };
    }
  }, [isClaimLoading, dispatch]);

  return (
    <Box>
      {isClaimLoading ? (
        <LinearProgress
          variant="determinate"
          value={linearProgressValue}
          sx={{
            '& .MuiLinearProgress-bar': {
              backgroundColor: BRIGHT_BLUE,
            },
          }}
        />
      ) : (
        <Box />
      )}
    </Box>
  );
};

export default LinearProgressBar;
